import { transformToNestObject as e } from "react-hook-form";
function r() {
  return (r = Object.assign || function (e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }).apply(this, arguments);
}
var t = function t(_t, n) {
  return void 0 === n && (n = {
    abortEarly: !1
  }), function (o, a, s) {
    void 0 === s && (s = !1);
    try {
      return Promise.resolve(function (e, s) {
        try {
          var c = (n.context && "development" === process.env.NODE_ENV && console.warn("You should not used the yup options context. Please, use the 'useForm' context object instead"), Promise.resolve(_t.validate(o, r({}, n, {
            context: a
          }))).then(function (e) {
            return {
              values: e,
              errors: {}
            };
          }));
        } catch (e) {
          return s(e);
        }
        return c && c.then ? c.then(void 0, s) : c;
      }(0, function (t) {
        if (!t.inner) throw t;
        var n = function (e, t) {
          var n;
          return Array.isArray(e.inner) && e.inner.length ? e.inner.reduce(function (e, n) {
            var o,
              a,
              s = n.path,
              c = n.message,
              u = n.type,
              i = e[s] && e[s].types || {},
              p = s || u;
            return r({}, e, p ? ((a = {})[p] = r({}, e[p] || {
              message: c,
              type: u
            }, t ? {
              types: r({}, i, (o = {}, o[u] = i[u] ? [].concat([].concat(i[u]), [c]) : c, o))
            } : {}), a) : {});
          }, {}) : ((n = {})[e.path] = {
            message: e.message,
            type: e.type
          }, n);
        }(t, s);
        return {
          values: {},
          errors: e(n)
        };
      }));
    } catch (e) {
      return Promise.reject(e);
    }
  };
};
export { t as yupResolver };